export { RatingsAreaChart, RatingsAreaChartProps } from './RatingsAreaChart';
